export default __webpack_public_path__ + "static/ktx-logo-79603ec986e1f70885562e74ffead829.svg";